import { useState, useCallback } from "react";
import { useAuth } from "../../../components/context/LoginContext/AuthContext";

/**
 * Admin - Issue Draft Invoice
 */
export const useIssueInvoice = () => {
  const { user, fetchWithAuth } = useAuth();
  const apiUrl = process.env.REACT_APP_API_URL;

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const issueInvoice = useCallback(
    async (invoiceId) => {
      if (!user?.token) throw new Error("Unauthorized");
      if (!invoiceId) throw new Error("Invoice ID missing");

      setLoading(true);
      setError(null);

      try {
        const response = await fetchWithAuth(
          `${apiUrl}/school/invoices/${invoiceId}/issue`,
          { method: "POST" }
        );

        const result = await response.json();

        if (!response.ok || !result.success) {
          throw new Error(result.message || "Failed to issue invoice");
        }

        return result;
      } catch (err) {
        console.error("Issue Invoice Error:", err);
        setError(err.message || "Something went wrong");
        throw err;
      } finally {
        setLoading(false);
      }
    },
    [apiUrl, fetchWithAuth, user]
  );

  return { issueInvoice, loading, error };
};
